// src/lib/dep-mapping.js
// Normaliseert dep-naam uit rollen naar key in TIMESHEETS. Pure mapping.
// Retourneert null als het departement geen timesheet-sjabloon heeft (bv. festival).

const MAPPING = {
  "Scenario": "scenario",
  "Regie": "regie",
  "Casting en Acteren": "casting-acteren",
  "Uitvoerende productie": "uitvoerende-productie",
  "Art, Kostuum, Hair & Make Up": "art-costume-hair-makeup",
  "Camera, Licht en Grip": "camera-licht-grip",
  "Productie geluid": "productie-geluid",
  "Montage": "montage",
  "Beeld postproductie": "beeld-postproductie",
  "Geluid postproductie": "geluid-postproductie",
  "Muziek": "muziek",
  "VFX en VP": "vfx-vp",
  "Animatie": "animatie",
};

export function depToTimesheetKey(dep) {
  return MAPPING[dep] || null;
}
